import script from "./ComplaintOrderList.vue?vue&type=script&lang=ts&setup=true&name=ComplaintOrderList"
export * from "./ComplaintOrderList.vue?vue&type=script&lang=ts&setup=true&name=ComplaintOrderList"

const __exports__ = script;

export default __exports__